import {AnalyticsService} from "../../../third-party-services/analytics/analytics-service";
import {AnalyticsEventHandler} from "../../../infrastructure/handlers/analytics-event-handler";
import {BoxScoresWidgetLineupsToggleClickAnalyticsEvent} from "../models/box-scores-widget.lineups-toggle-click.analytics-event";
import {BOX_SCORES_WIDGET} from "../box-scores-widget-consts";

export class BoxScoresWidgetLineupsToggleClickAnalyticsEventHandler extends AnalyticsEventHandler {
  analyticsService: AnalyticsService;
  type = BOX_SCORES_WIDGET.ANALYTICS.ACTION_TYPES.toggleClick;

  static injectables = [AnalyticsService];

  constructor(analyticsService: AnalyticsService) {
    super(analyticsService);

    this.eventType = BoxScoresWidgetLineupsToggleClickAnalyticsEvent;
  }
}
